import {DrawerBody, DrawerHeader} from '@cypro/ui/components'
import {Drawer, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {PrescribedNameDrawerTabsList} from './tabs-list'
import {AboutTab} from './tabs/about'
import {TradeNamesTab} from './tabs/trade-names'

export function PrescribedNameDrawer() {
  const {t} = useTranslate('common')

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{t('prescribed_name_details')}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody>
        <Tabs.Root defaultValue="about" spaceY="5" lazyMount>
          <PrescribedNameDrawerTabsList />

          <AboutTab />
          <TradeNamesTab />
        </Tabs.Root>
      </DrawerBody>
    </>
  )
}
